(function () {

  var element = document.querySelectorAll('.js-page-scroll')
  if(!element) return

  for(var i=0;i<element.length;i++) {
    element[i].addEventListener('click', pagetopClick)
  }

  function pagetopClick(e) {
    e.preventDefault()
  
    var event

    try {
      event = new CustomEvent('page-scroll')
    } catch (error) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('page-scroll', false, false, {})
    }

    window.dispatchEvent(event);

    var target = document.querySelector(e.target.getAttribute('href'))

    var targetTop = offsetTop(target)
    window.scrollTo({
      top: targetTop,
      behavior: "smooth"
    })
  }

  var offsetTop = function(target) {
    var rect = target.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

}());